// removed by extract-text-webpack-plugin
module.exports = {"modal":"Modales__modal___3_OZU","modalHospedaje":"Modales__modalHospedaje___2Tx9t","form__error-message":"Modales__form__error-message___3Zd6q","form__control-label":"Modales__form__control-label___2tP5L"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/proveedores/hospedajes/Modales.css
// module id = 972
// module chunks = 0